import "./PaidTrafficManagement.module.css";
import Header from "@/reusable_sections/Header";
import PrecisionEngineeringHub from "./sections/PrecisionEngineeringHub";
import WhatsIncludedInACreditReport from "./sections/WhatsIncludedInACreditReport";
import TravelMedicine from "./sections/TravelMedicine";
import Leistungen from "./sections/Leistungen";
import OperationalEfficiency from "./sections/OperationalEfficiency";
import ConversaoFinal from "./sections/ConversaoFinal";
import Footer from "@/reusable_sections/Footer";
export default function PaidTrafficManagementPage() {
  return <div>
      <Header />
      <PrecisionEngineeringHub />
      <WhatsIncludedInACreditReport />
      <TravelMedicine />
      <Leistungen />
      <OperationalEfficiency />
      <ConversaoFinal />
      <Footer />
    </div>;
}